<template>
  <div class="">
    <cReviewHotel
      v-if="!isCountryTax"
      :hotelObj="hotelObj"
      :isToggleOption="true"
      :isEditOption="true"
      :isShowLeftPart="true"
      :isHideDetails="true"
    />

    <cHotelTaxSetup
      :isHotelTax="!isCountryTax"
      @onTaxSetupFormSave="navToHotelInfo"
      @onTaxSetupFormCancel="navToHotelInfo"
    >
    </cHotelTaxSetup>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import cReviewHotel from "../../../../../components/hms/cReviewHotel";
import {
  COMPONENT_NAME,
  PATHNAME,
  ALERT_MODAL_STATUS,
} from "../../../../../util/constants";
import Logger from "../../../../../services/logger";
import multiselect from "vue-multiselect";
import BaseConfiguration from "../../../../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneDeep,
  cloneData,
} from "../../../../../util/util";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../../../config/API_DATA";
import apiGetHotelRooms from "../../../../../services/apiGetHotelRooms";
import cTextInputComponent from "../../../../../components/form/cTextInputComponent";
import apiCreateHotelCancellationPolicy from "../../../../../services/apiCreateHotelCancellationPolicy";
import apiUpdateCancelPolicy from "../../../../../services/apiUpdateCancelPolicy";
import apiGetCurrencyLs from "../../../../../services/apiGetCurrencyLs.js";
import apiGetRatePlan from "../../../../../services/apiGetRatePlan";
import { mapGetters, mapActions } from "vuex";
import datePickerInput from "../../../../../components/datePicker/datePickerInput";
import { VMdDateRangePicker } from "material-vue-date-picker";
import cHotelTaxSetup from "../../../../../components/hms/manage/hotelInfo/cHotelTaxSetup";
import router, { navigate, goBack } from "../../../../../router/index";
import cAlertModal from "../../../../../components/form/cAlertModal";
export default {
  name: COMPONENT_NAME.HOTEL_TAX_NEW,
  components: {
    cHotelTaxSetup,
    cReviewHotel,
  },
  computed: {
    ...mapGetters("sCurrencyLs", {
      allCurrencyList: "GET_CURRENCY_RES",
    }),
    ...mapGetters("shmsManage", {
      hotelObj: "GET_SEL_HOTEL",
    }),
    ...mapGetters("sHotelTax", {
      isCountryTax: "GET_IS_COUNTRY_TAX",
    }),
  },
  methods: {
    ...mapActions("sCurrencyLs", ["SET_CURRENCY_RES"]),

    async setCurrencyListRes() {
      // this.countrySel=true;

      try {
        let currencyLsResponse = await apiGetCurrencyLs.getResponse();
        if (
          VALIDATE_SUCCESS_RES(currencyLsResponse) &&
          currencyLsResponse.data.data.length > 0
        ) {
          this.SET_CURRENCY_RES(currencyLsResponse.data.data); //save res in store
          ///  retValue = currencyLsResponse.data.data;
          // console.log(countryLsResponse.data.data);
        } else {
          let error = getErrorMessage(currencyLsResponse);

          let isJwt = handleJWT(error);
          if (!isJwt) {
            getErrorAlertValue(error);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_TAX_NEW,
          "error in getting response from GetCurrencyLs API",
          err.toString(),
          "GetCurrencyLsRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navToHotelInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToHotelInfo");

        goBack();
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_TAX_NEW,
          "error in navToHotelInfo",
          err.toString(),
          "navToHotelInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },


 async created() {
      try {
        if(BaseConfiguration.isDebug) console.log("created");
        if(!this.allCurrencyList)
        {
        await this.setCurrencyListRes()
        }
  
      } catch (err) {
              let body = Logger.buildRequest(
              COMPONENT_NAME.HOTEL_TAX_NEW ,
                "error in created",
                err.toString(),
                "created",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
       
      }, 
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.HOTEL_TAX_NEW);
  },

  beforeDestroy() {
    removeClassBody();
  },
};
</script>

<style></style>
